import { defineMessages } from 'react-intl';

export const i18n: {
	clearFilters: {
		id: string;
		defaultMessage: string;
	};
	suggestedFilters: {
		id: string;
		defaultMessage: string;
	};
} = defineMessages({
	clearFilters: {
		id: 'search-page.filters.clear-filters-button-label',
		defaultMessage: 'Clear filters',
	},
	suggestedFilters: {
		id: 'search-page.filters.suggested-filters-section-label',
		defaultMessage: 'Suggested',
	},
});
